<template>
  <div
      class="activity-container p-6 bg-white my-4 flex items-center justify-between"
  >
    <div class="flex items-center">
      <el-image
          v-if="getThumbnailImage()"
          :src="getThumbnailImage()"
          class="cover mr-3"
          fit="cover"
          :preview-src-list="[getThumbnailImage()]"
      >
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>
      <div class="activity-info flex-1" style="width: 100%;padding-right: 20px;box-sizing: border-box">
        <p class="activity-name text-base font-bold mb-4 mt-3" style="margin: 2px 0px">
          {{ info.title }}
        </p>
        <div class="activity-desc">
          <p class="text-sm content" v-html="getPreviewContent()"></p>
        </div>

        <div style="margin-top: 3px" class="flex">
          <span v-if="getGroupName()" class="common-tag" style="margin-right: 15px">
            {{ getGroupName() }}
          </span>
        </div>

      </div>
    </div>
    <div>
      <el-button type="primary" class="mr-2" @click="handleView"
      >View
      </el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "ActivityAdvice",
  props: {
    info: Object,
    index: Number,
  },
  methods: {
    handleView() {
      this.$emit("view");
    },
    getPreviewContent() {
      // Use first_text_answer content if available, otherwise fall back to content
      if (this.info.first_text_answer && this.info.first_text_answer.content) {
        const content = this.info.first_text_answer.content.trim();
        // Remove markdown syntax for preview
        let cleanContent = content
          .replace(/^#+\s+/gm, '')
          .replace(/\*\*([^*]+)\*\*/g, '$1')
          .replace(/__([^_]+)__/g, '$1')
          .replace(/\*([^*]+)\*/g, '$1')
          .replace(/_([^_]+)_/g, '$1')
          .replace(/\[([^\]]+)\]\([^\)]+\)/g, '$1')
          .replace(/!\[([^\]]*)\]\([^\)]+\)/g, '')
          .replace(/```[\s\S]*?```/g, '')
          .replace(/`([^`]+)`/g, '$1')
          .replace(/^[\s]*[-*+]\s+/gm, '')
          .replace(/^\d+\.\s+/gm, '')
          .replace(/^>\s+/gm, '')
          .replace(/\n+/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();
        return cleanContent.substring(0, 110);
      }
      return this.info.content || '';
    },
    getThumbnailImage() {
      // Get first image from first_image_answer
      if (this.info.first_image_answer && this.info.first_image_answer.fileList && this.info.first_image_answer.fileList.length > 0) {
        const imageItem = this.info.first_image_answer.fileList[0];
        // Extract URL from image item (could be a string URL or an object with url property)
        if (typeof imageItem === 'string') {
          return imageItem;
        }
        return imageItem.url || imageItem.src || imageItem.data?.url || null;
      }
      return null;
    },
    getGroupName() {
      return this.info.group_name || null;
    },
  },
};
</script>

<style lang="scss" scoped>
.activity-container {
  .sort {
    font-size: 16px;
    padding: 2px 8px;
    color: var(--c-primary);
    background-color: #ffefed;
    height: fit-content;
  }

  .cover {
    width: 96px;
    height: 96px;
    border-radius: 4px;
    object-fit: cover;
    flex-shrink: 0;
  }

  .image-slot {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    color: #909399;
    font-size: 30px;
  }

  .content {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .activity-info {
    //height: 96px;
    .activity-name {
      color: #333333;
    }

    .activity-time {
      color: var(--c-primary);

      span {
        color: #999999;
      }

      p {
        margin-right: 45px;
      }
    }

    .activity-location {
      color: #ff8900;

      span {
        color: #999999;
      }

      p {
        margin-right: 60px;
      }
    }

    .activity-desc {
      color: #666666;
      height: 42px;
      overflow: hidden;
    }
  }
}
</style>
